<template>

</template>

<script>
  import 'jquery-validation'
  import 'flatpickr'
  import 'flatpickr/dist/flatpickr.min.css'
  import { Spanish } from 'flatpickr/dist/l10n/es'
  import moment from 'moment'
  import autosize from 'autosize'
  
  export default {
    name: 'EditProtocol',
    data () {
      return {
        editing: true,
      }
    },
    created () {
      if (typeof window.editing !== 'undefined' || window.editing !== null) {
        this.editing = window.editing
      }
    },
    mounted () {
      /**
       * Show collapsed inputs
       */
      showInputs()
      
      $(window).on('pageshow', function () {
        showInputs()
      })
      
      const $startDate = $('#start_date')
      const $endDate   = $('#end_date')
      
      if (window.protocol) {
        this.protocol = window.protocol
      }
      
      autosize($('textarea'))
      
      /**
       * Apply date pickers.
       **/
      const vm = this
      
      function getMinDate () {
        const startDate = moment(window.protocol.start_date)
        const today     = moment()
        
        if (today.diff(startDate, 'days') === 0) {
          return today.subtract(1, 'days').format('DD/MM/YYYY')
        }
        
        return new Date()
      }
      
      if (this.editing) {
        $startDate.flatpickr({
          disableMobile: false,
          dateFormat: 'd/m/Y',
          locale: Spanish,
          minDate: protocol && protocol.start_date ? moment(protocol.start_date).format('DD/MM/YYYY') : new Date(),
          onChange (dates, dateStr, instance) {
            const date = moment(dates[0]).add(1, 'd').format('DD/MM/YYYY')
            vm.endDate.set('minDate', date)
          },
        })
        
        $endDate.flatpickr({
          disableMobile: false,
          dateFormat: 'd/m/Y',
          locale: Spanish,
        })
        
        this.starDate = $startDate.get(0)._flatpickr
        this.endDate  = $endDate.get(0)._flatpickr
        
        if (protocol) {
          this.starDate.setDate(protocol.start_date)
          this.endDate.setDate(protocol.end_date)
        }
      }
      
      function showInputs () {
        $('.show-collapse:checked').each(function (key, input) {
          let target = $($(this).attr('data-target').replace(':not(.show)', ''))
          target.addClass('show')
        })
      }
      
      /**
       * Init Select2 and make ajax search
       */
      const $search = $('.search-select-multiple-institutions')
      
      $search.select2({
        placeholder: 'Selecciones instituciones',
        tokenSeparators: [','],
        language: {
          noResults: function () {
            return 'No se encontraron instituciones disponibles...'
          },
        },
      })
      
      const $searchKeywords = $('.search-select-multiple-keywords')
      
      $searchKeywords.select2({
        placeholder: 'Ingrese palabras clave',
        tokenSeparators: [','],
        tags: true,
        language: {
          noResults: function () {
            return 'Aún no asigna palabras clave'
          },
        },
      })
      
      $(() => {
        $('.form').validate({
          ignore: [],
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            if (element.hasClass('search-select-multiple-keywords') ||
              element.hasClass('search-select-multiple-institutions')) {
              label.insertAfter(element.siblings('span.select2'))
            }
            else {
              label.insertAfter(element)
            }
            
            label.addClass('invalid-feedback')
          },
          rules: {
            title: {
              required: true,
            },
            study_type_id: {
              required: true,
            },
            summary: {
              required: true,
            },
            'keywords[]': {
              required: true,
            },
            start_date: {
              required: true,
            },
            end_date: {
              required: true,
            },
            overall_objective: {
              required: true,
            },
            specific_objective: {
              required: true,
            },
            research_type_id: {
              required: true,
            },
            in_collaboration: {
              required: true,
            },
            'institutions[]': {
              required: function () {
                return $('[name="in_collaboration"]:checked').val() != ''
              },
            },
            is_related_emergency: {
              required: true,
            },
            emergency_description: {
              required: Number($(':radio[name="is_related_emergency"]:checked').val()) === 1
            },
          },
          messages: {
            title: {
              required: 'Este campo es requerido.',
            },
            summary: {
              required: 'Este campo es requerido.',
            },
            'keywords[]': {
              required: 'Este campo es requerido.',
            },
            start_date: {
              required: 'Este campo es requerido.',
            },
            end_date: {
              required: 'Este campo es requerido.',
            },
            overall_objective: {
              required: 'Este campo es requerido.',
            },
            specific_objective: {
              required: 'Este campo es requerido.',
            },
            research_type_id: {
              required: 'Este campo es requerido.',
            },
            in_collaboration: {
              required: 'Este campo es requerido.',
            },
            'institutions[]': {
              required: 'Este campo es requerido.',
            },
            is_related_emergency: {
              required: 'Este campo es requerido.',
            },
            emergency_description: {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler (form) {
            $('button[type="submit"]').prop('disabled', true)
            $('#btn-cancel').addClass('disabled')
            $('#btn-save > .spinner-border').removeClass('d-none')
            
            form.submit()
          },
        })
        
        $('#protocol-form').removeClass('invisible')
        
        if (!this.editing) {
          $(':input, select, textarea').prop('disabled', true)
        }
      })
    },
  }
</script>
